import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPlus, FaMoneyBillWave, FaTrash, FaSortAmountUp, FaSortAmountDown, FaClipboardList, FaExclamationCircle, FaEye, FaEllipsisV } from "react-icons/fa";
import axios from "axios";
import useAuth from "../dashboard/useAuth";
import Sidebar from "../dashboard/sidebar";
import Navbar from "../dashboard/navbar";

const Mes_achats = ({ titre }) => {
    useAuth();
    const [achats, setAchats] = useState([]);
    const [selectedAchat, setSelectedAchat] = useState(null);
    const [menu, setMenu] = useState(null);
    const menuRef = useRef(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_achat", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showRemboursementModal, setShowRemboursementModal] = useState(false);
    const [motifRemboursement, setMotifRemboursement] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const user_id = localStorage.getItem("IDDDD");
    const [showQRModal, setShowQRModal] = useState(false);
    const [qrCodeData, setQrCodeData] = useState("");
    const [filtreTypeProduit, setFiltreTypeProduit] = useState("tous"); // 'tous', 'unique', 'abonnement'
    const [filtreAbonnement, setFiltreAbonnement] = useState("tous"); // 'tous', 'mensuel', 'annuel'

    useEffect(() => {
        if (user_id) {
            document.title = "PayMe | Mes Achats";
            verifGroupe();
            fetchAchats();
        }
    }, [user_id]);

    const fetchAchats = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-achats-utilisateur/${user_id}/`);
            console.log("Tous les achats du back reçus:", response.data);

            // Vérification que la réponse a bien la structure attendue
            if (response.data && response.data.status === 'success' && Array.isArray(response.data.achats)) {
                setAchats(response.data.achats);
            } else {
                console.error("Structure de données inattendue:", response.data);
                setAchats([]);
                showAlert("Format de données incorrect", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setAchats([]);
            showAlert("Erreur lors du chargement des achats", "danger");
        }
    };

    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    // if (!accesGroupe.includes("Produits")) {
    //     return null;
    // }

    const MenuItem = ({ icon, color, label, onClick }) => (
        <li className="context-menu-item" onClick={onClick}>
            <span className="context-menu-icon" style={{ color }}>
                {icon}
            </span>
            <span>{label}</span>
        </li>
    );
    const menuStyle = {
        position: "absolute",
        backgroundColor: "#f8f9fa",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        borderRadius: "4px",
        zIndex: 1050,
        minWidth: "150px",
        border: "1px solid #ced4da",
        padding: "5px 0",
        right: "auto", // S'assure qu'il n'y a pas de position right
        left: 0, // Positionné à gauche
    };

    const menuItemStyle = {
        padding: "8px 16px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        ":hover": {
            backgroundColor: "#f5f5f5",
        },
    };
    const handleClick = (event, achat) => {
        event.stopPropagation();

        if (menu?.achat?.achat_id === achat.achat_id) {
            setMenu(null);
            return;
        }

        const button = event.currentTarget;
        const rect = button.getBoundingClientRect();

        setMenu({
            achat,
            x: rect.right - 240, // Ajustez cette valeur pour l'alignement horizontal
            y: rect.bottom + window.scrollY + 1, // Petit décalage vers le bas
        });
    };

    const closeMenu = () => setMenu(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton = event.target.closest(".action-button");
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !isActionButton
            ) {
                closeMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu]);

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const filteredAchats = achats.filter(achat => {
        const matchesSearch =
            achat.nom_utilisateur.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.nom_produit.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.transaction_id.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filtreStatut === "tous" || achat.statut === filtreStatut;

        // Filtre pour type de produit (achats uniques ou abonnements)
        const matchesTypeProduit =
            filtreTypeProduit === "tous" ||
            (filtreTypeProduit === "unique" && (achat.subscription_type === null || achat.subscription_type === "")) ||
            (filtreTypeProduit === "abonnement" && achat.subscription_type && achat.subscription_type !== "");

        return matchesSearch && matchesStatus && matchesTypeProduit;
    });

    const sortedAchats = [...filteredAchats].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastAchat = currentPage * itemsPerPage;
    const indexOfFirstAchat = indexOfLastAchat - itemsPerPage;
    const currentAchats = sortedAchats.slice(indexOfFirstAchat, indexOfLastAchat);
    const totalPages = Math.ceil(sortedAchats.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    const handleSubmitRemboursement = async () => {
        if (!selectedAchat || !motifRemboursement) {
            showAlert("Veuillez sélectionner un achat et indiquer un motif", "danger");
            return;
        }

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_HOTE}/soumettre-demande-remboursement/${selectedAchat.achat_id}/`,
                {
                    motif: motifRemboursement,
                    statut: "En traitement" // Mettre à jour le statut
                }
            );

            if (response.data.status === 'success') {
                showAlert("Demande de remboursement envoyée avec succès!");
                setShowRemboursementModal(false);
                setMotifRemboursement("");
                fetchAchats(); // Rafraîchir la liste des achats
            } else {
                showAlert(response.data.message || "Erreur lors de la demande", "danger");
            }
        } catch (error) {
            console.error("Erreur lors de la demande", error);
            showAlert("Erreur lors de la demande de remboursement", "danger");
        }
    };

    const handleShowQRCode = async (achat) => {
        setQrCodeData("");
        setSelectedAchat(achat);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_HOTE}/achat-qr-code/${achat.achat_id}/`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );
            console.log("Informations de l'achat:", response.data);
            setQrCodeData(response.data.qr_code_url || "");
            setShowQRModal(true);
        } catch (error) {
            console.error("Erreur lors de la récupération du QR code:", error);
            setQrCodeData("");
            setShowQRModal(true);
        }
    };
    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <FaClipboardList size={25} className="mr-2" /> Mes achats
                        </h2>
                        <small>Gestion des achats.</small>
                    </div>
                </div>

                <div className="mt-3">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                        <h5>Liste des achats</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                {/* <button
                                    className="btn btn-success mr-2"
                                    onClick={() => {
                                        if (!selectedAchat) {
                                            showAlert("Veuillez sélectionner un achat", "warning");
                                        } else {
                                            setShowRemboursementModal(true);
                                        }
                                    }}
                                >
                                    <FaPlus /> Demander un remboursement
                                </button> */}
                                <button className="btn btn-success mr-2">
                                    <FaPlus /> Exporter
                                </button>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>

                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreTypeProduit}
                                                onChange={(e) => {
                                                    setFiltreTypeProduit(e.target.value);
                                                    setCurrentPage(1); // Réinitialiser à la première page lors du changement de filtre
                                                }}
                                            >
                                                <option value="tous">Tous les achats</option>
                                                <option value="unique">Achats uniques</option>
                                                <option value="abonnement">Abonnements</option>
                                            </select>

                                            {/* <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreAbonnement}
                                                onChange={(e) => {
                                                    setFiltreAbonnement(e.target.value);
                                                    setCurrentPage(1); // Réinitialiser à la première page lors du changement de filtre
                                                }}
                                            >
                                                <option value="tous">Tous</option>
                                                <option value="mensuel">Mensuel</option>
                                                <option value="annuel">Annuel</option>
                                            </select> */}
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "150px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    {/* Table for Desktop */}
                                    <div className="table-responsive d-md-block d-none">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    {filtreTypeProduit === "abonnement" ? (
                                                        <>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("nom_produit")}
                                                                style={{ width: "2%", minWidth: "100px" }}
                                                            >
                                                                Produit 
                                                                {sortConfig.key === "nom_produit"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("prix_unitaire")}
                                                                style={{ width: "12%", minWidth: "80px" }}
                                                            >
                                                                Prix unitaire 
                                                                {sortConfig.key === "prix_unitaire"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("nom_vendeur")}
                                                                style={{ width: "5%", minWidth: "120px" }}
                                                            >
                                                                Vendeur 
                                                                {sortConfig.key === "nom_vendeur"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-center text-wrap align-middle"
                                                                onClick={() => handleSort("subscription_type")}
                                                                style={{ width: "10%", minWidth: "100px" }}
                                                            >
                                                                Type 
                                                                {sortConfig.key === "subscription_type"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("date_debut")}
                                                                style={{ width: "11%", minWidth: "100px" }}
                                                            >
                                                                Date de début 
                                                                {sortConfig.key === "date_debut"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("date_fin")}
                                                                style={{ width: "9%", minWidth: "100px" }}
                                                            >
                                                                Date de fin 
                                                                {sortConfig.key === "date_fin"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("subscription_type")}
                                                                style={{ width: "8%", minWidth: "100px" }}
                                                            >
                                                                Statut abonnement 
                                                                {sortConfig.key === "subscription_type"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                style={{ width: "5%", minWidth: "50px" }}
                                                            >
                                                                Actions
                                                            </th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th
                                                                className="text-secondary text-wrap"
                                                                onClick={() => handleSort("date_achat")}
                                                                style={{ width: "13%", minWidth: "100px" }}
                                                            >
                                                                Date d'achat 
                                                                {sortConfig.key === "date_achat" } { (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("nom_produit")}
                                                                style={{ width: "12%", minWidth: "80px" }}
                                                            >
                                                                Produit 
                                                                {sortConfig.key === "nom_produit" } { (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("prix_unitaire")}
                                                                style={{ width: "12%", minWidth: "80px" }}
                                                            >
                                                                Prix unitaire 
                                                                {sortConfig.key === "prix_unitaire" } { (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("quantite")}
                                                                style={{ width: "10%", minWidth: "70px" }}
                                                            >
                                                                Quantité 
                                                                {sortConfig.key === "quantite" } { (sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("total")}
                                                                style={{ width: "12%", minWidth: "80px" }}
                                                            >
                                                                Total 
                                                                {sortConfig.key === "total"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                onClick={() => handleSort("mode_paiement")}
                                                                style={{ width: "15%", minWidth: "100px" }}
                                                            >
                                                                Paiement 
                                                                {sortConfig.key === "mode_paiement"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap align-middle"
                                                                onClick={() => handleSort("nom_vendeur")}
                                                                style={{ width: "12%", minWidth: "150px" }}
                                                            >
                                                                Vendeur 
                                                                {sortConfig.key === "nom_vendeur"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap"
                                                                onClick={() => handleSort("transaction_id")}
                                                                style={{ width: "10%", minWidth: "100px" }}
                                                            >
                                                                Transaction 
                                                                {sortConfig.key === "transaction_id"} {(sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap text-center align-middle"
                                                                style={{ width: "5%", minWidth: "50px" }}
                                                            >
                                                                Actions
                                                            </th>
                                                        </>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentAchats && currentAchats.length > 0 ? (
                                                    currentAchats.map((achat) => (
                                                        <tr key={achat.achat_id}>
                                                            {filtreTypeProduit === "abonnement" ? (
                                                                <>
                                                                    <td style={{ paddingTop: "0.8rem" }}>
                                                                        <span className="text-dark">{achat.nom_produit}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{formatCurrency(achat.prix_unitaire)}</span>
                                                                    </td>
                                                                    <td style={{ paddingTop: "0.8rem" }}>
                                                                        <div className="fw-semibold">{achat.nom_vendeur}</div>
                                                                    </td>
                                                                    <td className="align-middle text-center" style={{ padding: "0.5rem" }}>
                                                                        <span className="badge fw-semibold">{achat.subscription_type}</span>
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{achat.datedebutabon ? new Date(achat.datedebutabon).toLocaleString() : 'N/A'}</span>
                                                                    </td>
                                                                    <td className="align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{achat.datefinabon ? new Date(achat.datefinabon).toLocaleString() : 'N/A'}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="badge fw-semibold bg-success text-white">
                                                                            {achat.statutabon || 'N/A'}
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center" style={{ padding: "0.5rem" }}>
                                                                        <button
                                                                            onClick={(e) => handleClick(e, achat)}
                                                                            className="btn btn-sm btn-gray action-button"
                                                                        >
                                                                            <FaEllipsisV />
                                                                        </button>
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <td className="align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{achat.date_achat ? new Date(achat.date_achat).toLocaleString() : 'N/A'}</span>
                                                                    </td>
                                                                    <td style={{ paddingTop: "0.8rem" }}>
                                                                        <span className="text-dark">{achat.nom_produit}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{formatCurrency(achat.prix_unitaire)}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{achat.quantite}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span className="fw-semibold">{formatCurrency(achat.total)}</span>
                                                                    </td>
                                                                    <td className="text-center align-middle" style={{ padding: "0.5rem" }}>
                                                                        <span>{achat.mode_paiement}</span>
                                                                    </td>
                                                                    <td style={{ paddingTop: "0.8rem" }}>
                                                                        <div className="fw-semibold">{achat.nom_vendeur}</div>
                                                                    </td>
                                                                    <td style={{ paddingTop: "0.8rem" }}>
                                                                        <div className="fw-semibold">{achat.transaction_id}</div>
                                                                    </td>
                                                                    <td className="text-center" style={{ padding: "0.5rem" }}>
                                                                        <button
                                                                            onClick={(e) => handleClick(e, achat)}
                                                                            className="btn btn-sm btn-gray action-button"
                                                                        >
                                                                            <FaEllipsisV />
                                                                        </button>
                                                                    </td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={filtreTypeProduit === "abonnement" ? 6 : 10} className="text-center">
                                                            Aucun achat trouvé
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Card Layout for Mobile */}
                                    <div className="d-md-none">
                                        <div className="mobile-list-container">
                                            {currentAchats && currentAchats.length > 0 ? (
                                                currentAchats.map((achat) => (
                                                    <div key={achat.achat_id} className="mobile-list-item">
                                                        <div className="mobile-list-content">
                                                            <div className="mobile-list-header d-flex justify-content-between align-items-center">
                                                                <div className="d-flex align-items-center">
                                                                    {achat.statut === "Acheté" ? (
                                                                        <span className="status-badge bg-success me-2"></span>
                                                                    ) : achat.statut === "En traitement" ? (
                                                                        <span className="status-badge bg-warning me-2"></span>
                                                                    ) : (
                                                                        <span className="status-badge bg-secondary me-2"></span>
                                                                    )}
                                                                    <span className="mobile-list-title">{achat.nom_produit}</span>
                                                                </div>
                                                                <div className="text-end">
                                                                    <span className="text-primary fw-bold">{formatCurrency(achat.total)}</span>
                                                                </div>
                                                            </div>

                                                            <div className="mobile-list-body">
                                                                {filtreTypeProduit === "abonnement" ? (
                                                                    <>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Type:</span>
                                                                            <span className="info-value">{achat.subscription_type}</span>
                                                                        </div>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Période:</span>
                                                                            <span className="info-value">
                                                                                {achat.datedebutabon ? new Date(achat.datedebutabon).toLocaleDateString() : 'N/A'} -
                                                                                {achat.datefinabon ? new Date(achat.datefinabon).toLocaleDateString() : 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Statut:</span>
                                                                            <span className={`badge ${achat.statutabon === 'actif' ? 'bg-success' : 'bg-secondary'}`}>
                                                                                {achat.statutabon || 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Date:</span>
                                                                            <span className="info-value">
                                                                                {achat.date_achat ? new Date(achat.date_achat).toLocaleString() : 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Quantité:</span>
                                                                            <span className="info-value">{achat.quantite} × {formatCurrency(achat.prix_unitaire)}</span>
                                                                        </div>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Vendeur:</span>
                                                                            <span className="info-value">{achat.nom_vendeur}</span>
                                                                        </div>
                                                                        <div className="info-row">
                                                                            <span className="info-label">Transaction:</span>
                                                                            <span className="info-value text-truncate d-block">{achat.transaction_id}</span>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div className="mobile-list-footer">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span className="text-muted small">
                                                                        {achat.mode_paiement}
                                                                    </span>
                                                                    <button
                                                                        onClick={(e) => handleClick(e, achat
                                                                        )}
                                                                        className="btn btn-sm btn-gray action-button"
                                                                    >
                                                                        <FaEllipsisV />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                ))
                                            ) : (
                                                <div className="no-results text-center p-4">
                                                    <FaExclamationCircle className="text-muted mb-2" size={24} />
                                                    <p className="mb-0">Aucun achat trouvé</p>
                                                </div>
                                            )}
                                        </div>


                                        {menu && createPortal(
                                            <div
                                                ref={menuRef}
                                                className="context-menu"
                                                style={{
                                                    ...menuStyle,
                                                    left: `${menu.x}px`,
                                                    top: `${menu.y}px`,
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <ul className="context-menu-list">
                                                    <MenuItem
                                                        icon={<FaMoneyBillWave />}
                                                        color="#000000"
                                                        label="Demander un remboursement"
                                                        onClick={() => {
                                                            setSelectedAchat(menu.achat);
                                                            setShowRemboursementModal(true);
                                                            closeMenu();
                                                        }}
                                                    />
                                                    <MenuItem
                                                        icon={<FaEye />}
                                                        color="#fd7e14"
                                                        label="Voir QR Code"
                                                        onClick={() => {
                                                            handleShowQRCode(menu.achat);
                                                            closeMenu();
                                                        }}
                                                    />
                                                </ul>
                                            </div>,
                                            document.body
                                        )}
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="dataTables_info" role="status" aria-live="polite">
                                            {sortedAchats.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstAchat + 1} à ${Math.min(indexOfLastAchat, sortedAchats.length)} sur ${sortedAchats.length}`}
                                        </div>

                                        <div>
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"
                                                        } mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal de demande de remboursement */}
            <Modal show={showRemboursementModal} onHide={() => setShowRemboursementModal(false)} centered>
                <Modal.Header>
                    <Modal.Title>Demande de remboursement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Motif</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            value={motifRemboursement}
                            onChange={(e) => setMotifRemboursement(e.target.value)}
                            placeholder="Veuillez indiquer le motif de la demande..."
                        ></textarea>
                    </div>
                    <div className="mt-2">
                        <small className="text-muted"> Achat de {selectedAchat?.quantite} {selectedAchat?.nom_produit} </small>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemboursementModal(false)}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleSubmitRemboursement}>
                        Soumettre
                    </Button>
                </Modal.Footer>
            </Modal>

            <style>
                {`
          .modal-content {
            border-radius: 0px;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
            border: none;
            background-color: #ffffff;
          }
          
          
          .qr-code-container {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .qr-code-image {
            background-color: #ffffff;
            border-radius: 8px;
            border: 1px solid #e5e7eb;
            padding: 8px;
            margin-bottom: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease;
          }
          .qr-code-image:hover {
            transform: scale(1.05);
          }
          .details-container {
            background-color: #f9fafb;
            border-radius: 8px;
            padding: 16px;
            width: 100%;
            text-align: left;
          }
          .detail-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 14px;
          }
          .detail-item:last-child {
            margin-bottom: 0;
          }
          .detail-label {
            color: #6b7280;
            font-weight: 500;
          }
          .detail-value {
            color: #1f2937;
            font-weight: 600;
            max-width: 60%;
            word-wrap: break-word;
          }
          .detail-value.green {
            color: #16a34a;
          }
          .error-container {
            padding: 24px;
            text-align: center;
          }
          .error-icon {
            background-color: #fef3c7;
            border-radius: 50%;
            padding: 16px;
            display: inline-flex;
            margin-bottom: 12px;
          }
          .error-title {
            font-size: 18px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 8px;
          }
          .error-message {
            color: #6b7280;
            font-size: 14px;
          }
          .close-button {
            padding: 8px 16px;
            border-radius: 8px;
            background-color:#69717e;
            color: #ffffff;
            border: none;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
          }
          .close-button:hover {
            background-color: #69717e;
            transform: translateY(-1px);
          }
          .mobile-list-container {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: #fff;
  padding: 10px;
}

.mobile-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e5e7eb;
  flex-direction: column;
}

.mobile-list-item:last-child {
  border-bottom: none;
}

.mobile-list-content {
  flex: 1;
  width: 100%;
}

.mobile-list-header {
  padding-bottom: 5px;
}

.mobile-list-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.mobile-list-body {
  padding: 8px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
}

.info-label {
  color: #666;
  font-weight: 500;
}

.info-value {
  color: #333;
}

.mobile-list-footer {
  padding-top: 5px;
}
          
            
        `}
            </style>
            <Modal
                show={showQRModal}
                onHide={() => setShowQRModal(false)}
                centered
                size="md"
                style={{ borderRadius: '20px' }}
            >
                <Modal.Body className="modal-body" style={{ padding: '26px', textAlign: 'center', borderRadius: '20px' }}>
                    <h5 className="" style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "16px 0"
                    }}>QR Code de l'achat</h5>
                    {qrCodeData ? (
                        <div className="qr-code-container">
                            <div className="qr-code-image">
                                <img
                                    src={qrCodeData}
                                    alt="QR Code de la transaction"
                                    className="img-fluid"
                                    style={{
                                        width: '200px',
                                        height: '200px',
                                        objectFit: 'contain',
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100%' height='100%' fill='%23f8f9fa'/%3E%3Ctext x='50%' y='50%' font-size='10' text-anchor='middle' dominant-baseline='middle' fill='%236c757d'%3EQR Code non disponible%3C/text%3E%3C/svg%3E";
                                    }}
                                />
                            </div>
                            {selectedAchat && (
                                <div className="details-container">
                                    <div className="detail-item">
                                        <span className="detail-label">Produit:</span>
                                        <span className="detail-value">{selectedAchat.nom_produit}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">Quantité:</span>
                                        <span className="detail-value">{selectedAchat.quantite}</span>
                                    </div>
                                    <div className="detail-item">
                                        <span className="detail-label">Total:</span>
                                        <span className="detail-value green">{formatCurrency(selectedAchat.total)}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="error-container">
                            <div className="error-icon">
                                <FaExclamationCircle size={32} className="text-warning" />
                            </div>
                            <h5 className="error-title">QR Code indisponible</h5>
                            <p className="error-message">Ce code QR n'est pas disponible pour cet achat</p>
                        </div>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <button className="close-button" onClick={() => setShowQRModal(false)}>
                            Fermer
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>

    );
};

export default Mes_achats;